import { constants } from '../constants/constants';
import { OlciActionTypes } from '../actions';
import { ArrivalTimesModel } from '../models';
import { ArrivalTimesGuestModel } from '../models/arrivaltimesmodel';

export interface State {
	arrivalTimesInv: any[];
	selectedArrivalTime: any;
	selectedArrivalTimesForAllGuestsByBooking: any[];
	selectedArrivalTimeVM: any;
	error: any;
}

export const initialState: State = {
	arrivalTimesInv: [],
	selectedArrivalTime: null,
	selectedArrivalTimesForAllGuestsByBooking: [],
	selectedArrivalTimeVM: null,
	error: null
};

export function reducer(
	state = initialState,
	action: any
): State {
	switch (action.type) {
		case OlciActionTypes.LOAD_ARRIVAL_APPOINTMENT_AND_INVENTORY_SUCCESS: {
			if (action.payload.status !== constants.HTTP_STATUS_CODE.SUCCESS) {
				return Object.assign({}, state, { error: action.payload.errors });
			}
			const arrivalTimesGuestSelected: ArrivalTimesGuestModel | null = getGuestArrivalAppointment(action.payload?.payload?.guestArrivalAppointments, action.payload?.firstAdultId);

			return Object.assign({}, state, {
					arrivalTimesInv: action.payload.payload.arrivalAppointmentInventory,
					selectedArrivalTime: arrivalTimesGuestSelected,
					selectedArrivalTimesForAllGuestsByBooking: action.payload.payload.guestArrivalAppointments
			});
		}

		case OlciActionTypes.UPDATE_ARRIVALTIMES_SELECTED_VM:
			return Object.assign({}, state, {
				selectedArrivalTimeVM: action.payload
			});

		case OlciActionTypes.POST_SET_UPDATE_ARRIVAL_TIMES_FAILURE: {
			const response = action.payload;
			if (response.status !== constants.HTTP_STATUS_CODE.SUCCESS) {
				return Object.assign({}, state, { error: response.errors });
			}
			return state;
		}

		default:
			return state;
	}
}

export const getGuestArrivalAppointment = (guestArrivalAppointments: ArrivalTimesModel[], firstAdultId: number): ArrivalTimesGuestModel | null => {
	const arrivalTimesGuest: ArrivalTimesGuestModel | undefined = guestArrivalAppointments.find(guestArrivalTime => {
			return  guestArrivalTime?.guests?.find(({guestId}: ArrivalTimesGuestModel) => findGuestByFirstAdultId(guestId, firstAdultId));
	})?.guests.find(({guestId}: ArrivalTimesGuestModel) => findGuestByFirstAdultId(guestId, firstAdultId));
	return arrivalTimesGuest || null;
}

const findGuestByFirstAdultId = (guestId: number, firstAdultId: number): boolean => guestId === firstAdultId;

export const getSelectedArrivalTime = (state: State) => state.selectedArrivalTime;
export const selectedArrivalTimesForAllGuestsByBooking = (state: State) => state.selectedArrivalTimesForAllGuestsByBooking;
